import React, { useState, useEffect } from 'react';
import {
  Card,
  CardHeader,
  FlexBox,
  Text,
  Label,
  Avatar,
} from '@ui5/webcomponents-react';

const WEATHER_API_KEY = '8efb9041a261430890c161140200812';
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function WeatherCard({ zipCode, country }) {
  const [forecast, setForecast] = useState(null);

  useEffect(() => {
    if (!zipCode) return;
    const q = country && country.toUpperCase() !== 'US' ? `${zipCode},${country}` : zipCode;
    const url = `https://api.weatherapi.com/v1/forecast.json?key=${WEATHER_API_KEY}&days=5&q=${q}`;

    fetch(url)
      .then(res => res.json())
      .then(data => {
        if (data.error || !data.forecast) return;
        const daily = data.forecast.forecastday.map(day => {
          const date = new Date(day.date + 'T12:00:00');
          return {
            day: DAYS[date.getDay()],
            date: `${date.getMonth() + 1}/${date.getDate()}`,
            high: Math.round(day.day.maxtemp_f),
            low: Math.round(day.day.mintemp_f),
            desc: day.day.condition.text,
            icon: day.day.condition.icon,
          };
        });
        setForecast(daily);
      })
      .catch(() => {});
  }, [zipCode, country]);

  if (!forecast) return null;

  return (
    <Card className="grid-card">
      <CardHeader
        avatar={<Avatar icon="temperature" colorScheme="Accent7" />}
        titleText="3 Day Weather"
        subtitleText="Local forecast"
      />
      <div className="card-body">
        <FlexBox justifyContent="SpaceBetween" className="weather-grid">
          {forecast.map((day, i) => (
            <FlexBox key={i} direction="Column" alignItems="Center" className="weather-day">
              <Label className="weather-day-label">{day.day}</Label>
              <img
                src={day.icon.startsWith('//') ? `https:${day.icon}` : day.icon}
                alt={day.desc}
                className="weather-icon"
              />
              <Text className="weather-temp">{day.high}°</Text>
              <Text className="weather-temp-low">{day.low}°</Text>
            </FlexBox>
          ))}
        </FlexBox>
      </div>
    </Card>
  );
}

export default WeatherCard;
